module.exports = __webpack_public_path__ + "static/media/D5A746A9-7BCF-4512-84FF-496B38E01A19.52062184.jpeg";